const advisorTakeSocialCriteria = {
    yes: 'Oui',
    no: 'Non',
};
export default advisorTakeSocialCriteria;
